import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_premium-relocate/artifacts/5rivambe_E0E9C5BC-6E65-42C6-BE70-BA64D36DBEB1.png";

/**
 * M&C Clean Fresh — official transparent logo.
 *
 * Props:
 *  - size: image height in px (for default: full logo height; for mark: emblem height)
 *  - variant:
 *      "default" → full transparent logo with wordmark (LIGHT backgrounds)
 *      "mark"    → cropped top portion showing only the gold M emblem (DARK backgrounds)
 *  - link: when true, wraps in <a href="#top">
 *  - className: extra classes
 */
export default function Logo({
  size = 48,
  variant = "default",
  link = true,
  className = "",
}) {
  if (variant === "mark") {
    // Render the official PNG but visually clip to just the top gold "M" emblem.
    // The image's M emblem occupies roughly the top 45% of the square logo.
    // We scale the image up so that 45% of it = `size`, then hide the rest with overflow.
    const emblemRatio = 0.45;
    const imageHeight = Math.round(size / emblemRatio);
    return (
      <div
        className={`inline-block ${className}`}
        style={{ height: size, overflow: "hidden", lineHeight: 0 }}
        data-testid="brand-logo"
      >
        <img
          src={LOGO_URL}
          alt="M&C Clean Fresh"
          draggable={false}
          className="select-none block"
          style={{ height: imageHeight, width: "auto" }}
        />
      </div>
    );
  }

  // Default: light backgrounds → full logo
  const img = (
    <img
      src={LOGO_URL}
      alt="M&C Clean Fresh"
      style={{ height: size }}
      className="w-auto object-contain select-none block"
      draggable={false}
    />
  );

  const Wrapper = link ? "a" : "div";
  const wrapperProps = link ? { href: "#top", "aria-label": "M&C Clean Fresh" } : {};

  return (
    <Wrapper className={`inline-flex items-center ${className}`} data-testid="brand-logo" {...wrapperProps}>
      {img}
    </Wrapper>
  );
}
